import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroPartner = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center pt-24 pb-20 overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900">
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text Content */}
          <div className="space-y-8 animate-fadeInUp">
            {/* Badge */}
            <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-brand-green/15 text-brand-green rounded-full text-sm font-semibold border border-brand-green/25">
              Partnerprogramm
            </div>

            {/* H1 */}
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.1] tracking-tight">
              Partner werden
              <br />
              <span className="gradient-text">und profitieren</span>
            </h1>

            {/* Subline */}
            <p className="text-lg lg:text-xl text-gray-400 leading-relaxed">
              Werden Sie Teil unseres bundesweiten Gutachten-Netzwerks.
              Faire Provisionen, einfacher Ablauf.
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a href="/partner/abo">
                <Button size="lg" className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-dark text-white text-base px-8 py-6 rounded-xl font-semibold shadow-xl shadow-brand-green/30">
                  Abo starten
                  <ArrowRight className="w-5 h-5 ml-2.5" />
                </Button>
              </a>
              <a href="/portal/login">
                <Button size="lg" variant="outline" className="w-full sm:w-auto border-2 border-white/30 text-white hover:bg-white/10 text-base px-8 py-6 rounded-xl font-semibold">
                  Bereits Partner? Login
                </Button>
              </a>
            </div>

            {/* Quick Info */}
            <p className="text-sm text-gray-400">
              ab 29,99 € inkl. MwSt./Monat • 30–50 % Provision • monatlich kündbar
            </p>
          </div>

          {/* Right: Image */}
          <div className="relative lg:block hidden">
            <div className="relative rounded-2xl overflow-hidden">
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent z-10"></div>
              
              <img 
                src="https://customer-assets.emergentagent.com/job_gutachten-direkt/artifacts/wrrkaapi_71823AAB-C105-4F06-BEA2-0BFD0772A977.png"
                alt="Moderne Werkstatt-Kooperation - Partner nutzt digitales Portal mit Tablet"
                className="w-full h-auto object-cover rounded-2xl shadow-2xl"
              />
            </div>
            
            {/* Badge: B2B Portal */}
            <div className="absolute bottom-6 left-6 z-20 bg-black/80 backdrop-blur-md border border-white/20 rounded-xl px-4 py-3">
              <p className="text-brand-green font-semibold text-sm">Partner-Portal</p>
              <p className="text-white/80 text-xs">Digitale Fallvermittlung</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
